import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useParams, useLocation } from 'react-router-dom';
import AlertPhoneDisplay from './AlertPhoneDisplay';
import AlertEmailDisplay from './AlertEmailDisplay';
import {
  loadAssignedAlertGroupList,
  loadAlertDeviceCategories,
  loadAlertDeviceDetails,
  loadUnassignedAlertDevicesDetails,
  loadAlertDeviceTypes,
  loadAlertGroups,
} from '../../../redux/actions/alertDeviceActions';
import { Link } from 'react-router-dom';
import SvgOpenExternal from '../../svg/OpenExternal';
import { loadUsers } from '../../../redux/actions/userActions';
import { loadUnits } from '../../../redux/actions/unitActions';

export function UnconnectedViewAlertDevice(props) {
  const { id } = useParams();
  const location = useLocation();
  const currentLocation = location.pathname + location.search;
  const {
    deviceDetails = {},
    users,
    units,
    alertDeviceTypes,
    alertDeviceDetails,
    alertGroupsArr = [],
    alertDeviceCategories,
  } = props;

  const {
    alert_device_id,
    alert_device_type,
    alert_device_category,
  } = deviceDetails || {
    alert_device_id: null,
    alert_device_type: null,
    alert_device_category: null,
  };

  useEffect(() => {
    props.dispatch(loadAlertDeviceCategories());
    props.dispatch(loadAssignedAlertGroupList());
    props.dispatch(loadAlertDeviceTypes());
    props.dispatch(loadUnassignedAlertDevicesDetails());
    props.dispatch(loadAlertGroups());
    props.dispatch(loadAlertDeviceDetails(id));
    props.dispatch(loadUnits());
    props.dispatch(loadUsers());
  }, []); // eslint-disable-line

  let assignedUsers = [];
  let assignedUnits = [];

  if (deviceDetails.user && deviceDetails.user.length > 0) {
    assignedUsers = deviceDetails.user.map((u) => {// eslint-disable-line
      const user = users[u];
      if (user) {
        return (
          <Link
            to={`/users/${user.id}/view/`}
            key={user.id}
            className="align-center">
            {`${user.first_name} ${user.last_name}`}
            <SvgOpenExternal className="margin-left-10" />
          </Link>
        );
      }
  });
  }
  if (deviceDetails.unit) {
    assignedUnits = deviceDetails.unit.map((u) => {// eslint-disable-line
      const unit = units[u];
      if (unit) {
        return (
          <Link
            to={`/units/${unit.id}/view/`}
            key={unit.id}
            data-test="assignment-link"
            className="align-center">
            {unit.name} <SvgOpenExternal className="margin-left-10" />
          </Link>
        );
      }
    });
  }

  const assignedInfo = [...assignedUsers, ...assignedUnits];

  let deviceType = '';
  if (alert_device_type && alertDeviceTypes[alert_device_type]) {
    deviceType = alertDeviceTypes[alert_device_type].description;
  }

  const assignedGroups = alertGroupsArr.filter(
    (group) => group.alert_device_id === alert_device_id
  );

  const assignedGroupNames = assignedGroups.map((g) => {// eslint-disable-line
    if (alertDeviceDetails[g.alert_group_id]) {
      return alertDeviceDetails[g.alert_group_id].alert_description;
    }
  });

  let alertCategoryName = '';
  if (alert_device_category && alertDeviceCategories[alert_device_category]) {
    alertCategoryName =
      alertDeviceCategories[alert_device_category].description;
  }

  function deviceDisplay() {
    switch (alert_device_type) {
      case 3:
        return (
          <AlertPhoneDisplay
            deviceDetails={deviceDetails}
            previous={currentLocation}
            assignedInfo={assignedInfo}
            deviceType={deviceType}
            assignedGroupNames={assignedGroupNames}
            alertCategoryName={alertCategoryName}
            data-test="display-type-3"
          />
        );
      case 24:
        return (
          <AlertPhoneDisplay
            deviceDetails={deviceDetails}
            previous={currentLocation}
            assignedInfo={assignedInfo}
            deviceType={deviceType}
            assignedGroupNames={assignedGroupNames}
            alertCategoryName={alertCategoryName}
            data-test="display-type-24"
          />
        );
      case 4:
        return (
          <AlertEmailDisplay
            deviceDetails={deviceDetails}
            previous={currentLocation}
            assignedInfo={assignedInfo}
            deviceType={deviceType}
            assignedGroupNames={assignedGroupNames}
            alertCategoryName={alertCategoryName}
            data-test="display-type-4"
          />
        );
      case 25:
        return (
          <AlertEmailDisplay
            deviceDetails={deviceDetails}
            previous={currentLocation}
            assignedInfo={assignedInfo}
            deviceType={deviceType}
            assignedGroupNames={assignedGroupNames}
            alertCategoryName={alertCategoryName}
            data-test="display-type-25"
          />
        );

      default:
        break;
    }
  }

  return (
    <div className="container" data-test="alert-device-display">
      <FormattedMessage
        id="alertDeviceDisplay.browserTabInfo"
        defaultMessage="Alert Devices | {id}"
        description="Done button"
        values={{
          id: deviceDetails.alert_device_id,
        }}>
        {(txt) => (
          <Helmet>
            <title>{txt}</title>
          </Helmet>
        )}
      </FormattedMessage>
      <div className="layout-container content-container content-container--column content-container--shadow" data-test="view-alert-device">
        {deviceDisplay()}
      </div>
    </div>
  );
}
const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;
  const alertGroupsArr = Object.values(state.devices.assignedAlertGroups);
  const alertDeviceDetails = state.devices.alertDeviceDetails;
  const deviceDetails = alertDeviceDetails[id];

  return {
    deviceDetails,
    users: state.users.users,
    units: state.units.units,
    alertDeviceTypes: state.devices.alertDeviceTypes,
    alertDeviceDetails,
    alertGroupsArr,
    alertDeviceCategories: state.devices.alertDeviceCategories,
  };
};

const ConnectedViewAlertDevice = connect(mapStateToProps)(UnconnectedViewAlertDevice);

function ViewAlertDeviceWrapper() {
  const { id } = useParams();
  return <ConnectedViewAlertDevice id={id} />;
}

export default ViewAlertDeviceWrapper;
